import { Button } from "react-bootstrap";

const DriversHeader = ({ searchTerm, onSearchChange, total, onAddDriver }) => {
  return (
    <div className="card-header d-flex justify-content-between align-items-center">
      <h4 className="card-title mb-0">Drivers ({total})</h4>
      <div className="d-flex gap-2 align-items-center">
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search drivers"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        <Button type="button" onClick={onAddDriver}>
          + Add Driver
        </Button>
      </div>
    </div>
  );
};

export default DriversHeader;
